const ADMIN_API_URL = {
  VERIFICATION: {
    LOGIN: "identity/admin/login",
    GET_MODULE_RIGHT: "identity/admin/GetUserModuleRights",
    REFRESH_TOKEN: "Identity/admin/refreshToken",
    CHANGE_PASSWORD: "Identity/admin/changePassword",
    CHANGE_USER_PASSWORD: "Identity/admin/ChangeUserPassword",
    USER_PROFILE_DATA: "Identity/admin/GetUserDetail",
    UPDATE_PROFILE: "Identity/admin/UpdateProfile",
  },
  TENANT: {
    SLUG: "BackOffice/Tenant",
  },
  TENANT_INQUIRY: {
    SLUG: "BackOffice/TenantInquiry",
    EXTERNAL_ADD: "BackOffice/TenantInquiry/Submited",
    APPROVE: "BackOffice/TenantInquiry/Approve",
    REJECT: "BackOffice/TenantInquiry/Rejected",
    CLOSE: "BackOffice/TenantInquiry/Closed",
  },
  EMAIL_PROVIDER: {
    SLUG: "BackOffice/EmailProvider",
  },
  EMAIL_CONFIGURATION: {
    SLUG: "BackOffice/TenantEmailConfiguration",
    SET_DEFAULT: "BackOffice/TenantEmailConfiguration/:id/set-default",
  },
  EMAIL_TEMPLATE: {
    SLUG: "BackOffice/EmailTemplate",
  },
  EMAIL_PLACEHOLDER: {
    SLUG: "BackOffice/EmailTemplatePlaceholder",
    LIST: "BackOffice/EmailTemplatePlaceholder/template",
  },
  EINVOICE_CONFIGURATION: {
    GET: (tenantId) => `BackOffice/EInvoiceConfig/${tenantId}`,
    SAVE: "BackOffice/EInvoiceConfig",
    TEST_CONNECTION: (tenantId) => `BackOffice/EInvoiceConfig/test-connection/${tenantId}`,
  },
  INVOICE_REPAIR: {
    POSTING_SIDE_EFFECTS: "BackOffice/Invoice/admin/repair-posting-side-effects",
  },
};

export default ADMIN_API_URL;
